var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconRefresh02 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 22 22"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M3.906 3.376A11.2 11.2 0 0 1 11 .853v1.06-1.06A10.175 10.175 0 1 1 .824 11.028V9.967h2.121v1.06A8.053 8.053 0 1 0 11 2.974h-.001a9.08 9.08 0 0 0-5.75 2.045l-.822.67-1.341-1.642z",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "m3.915.627 2.058.514-.702 2.805 2.805.701-.515 2.058L2.7 5.489z",
  clipRule: "evenodd"
})));
export default SvgIconRefresh02;